import { createAsyncThunk } from '@reduxjs/toolkit'

import {
  type ISearchInput,
  type ISearchResponse,
  objectToQueryString,
} from '@sales-center/common'

import type { TechRegionModel } from './typings'
import { ServiceConfig } from '../services/config'
import { get, type APIError } from '../services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.scheduling.scheduling}`

export const getTechRegions = createAsyncThunk<
  ISearchResponse<TechRegionModel>,
  ISearchInput | undefined,
  { rejectValue: APIError }
>('techRegions/get', async (request = {}, thunkApi) => {
  const qstring = objectToQueryString(request)

  const response = await get(
    `${baseUrl}${ServiceConfig.scheduling.region}?${qstring}`,
  )

  if (response.ok) return await response.json()
  return thunkApi.rejectWithValue(await response.json())
})
